module.exports = {"ru":{"modules":{"specialoffer":{"title":"Специальные предложения"}}}}